import { render, staticRenderFns } from "./ModelloForm.vue?vue&type=template&id=3e490606&scoped=true&"
import script from "./ModelloForm.vue?vue&type=script&lang=js&"
export * from "./ModelloForm.vue?vue&type=script&lang=js&"
import style0 from "./ModelloForm.vue?vue&type=style&index=0&id=3e490606&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e490606",
  null
  
)

component.options.__file = "ModelloForm.vue"
export default component.exports